import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserDetails from '../components/User/UserDetails';
import NotFound from '../components/NotFound';
import CompanyDetailsPage from './CompanyDetailsPage';
import UserManagementPage from './UserManagement';

const User = () => {
  return (
    <Routes>
      <Route path="/" element={<UserManagementPage />} />
      <Route path="/:id" element={<UserDetails />} />
      <Route path="/:id/user-companies/:companyId" element={<CompanyDetailsPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default User;
